import React from 'react';

import GeneralSuite from '../../../components/GeneralSuite';
import img1 from '../../../images/Rooms/pool/1.jpg';
import img2 from '../../../images/Rooms/pool/2.jpg';
import img3 from '../../../images/Rooms/pool/3.jpg';
import img4 from '../../../images/Rooms/pool/4.jpg';
import img5 from '../../../images/Rooms/pool/5.jpg';

import FancyButton from '../../../components/FancyButton';

const Pool = (props) => {
   return (
      <GeneralSuite
         Heading={"Pool View Suite"}
         Description={"Room Description"}
         width={"90px"}
         SupportImages={[img1, img2, img3, img4, img5]}
         DescriptionContent={() => <React.Fragment>
            <div style={{fontSize: '1.4rem', lineHeight: '2rem'}}>
               Our Pool View Suite is designed for guests who appreciate both elegance and tranquility.
            </div> <br />
            <div style={{fontSize: '1.4rem', lineHeight: '2rem'}}>
               This suite offers sweeping views of our all-weather sparkling pool, creating the perfect backdrop for a serene escape. Whether you’re here for a weekend getaway or an extended stay, our Pool View
               Suite offers the ideal combination of relaxation and luxury, allowing you to enjoy both the beauty of
               the water and the comforts of your room.
            </div> <br />
            <div style={{fontSize: '1.4rem', lineHeight: '2rem'}}>
               Savor your morning coffee or unwind with an evening drink, the pool view creates the perfect
               setting for any occasion.
            </div>
            <div
               style={{ display: 'flex', marginTop: '2rem' }}
            >
                  <a href= "https://bookings.hotelhilltone.com/?propertyId=8826">
              <FancyButton style={{margin: '1rem 0'}} text="Book a Stay" />
              </a>
            </div>
         </React.Fragment>}
         roomType={"pool"}
         backFlag={true}
         {...props}
      />
   );
}

export default Pool;